import React from "react";

const Dashboard = () => {
 // const getProfile = use;
  return <div>Dashboard</div>;
};

export default Dashboard;
